export default "__VITE_ASSET__CApA7Kvd__"